import { TransactionEntryCategoryFieldsFragment } from '../../graphql/generated';
import { buildBaseCategoryGroups } from './buildBaseCategoryGroups';
import { formatSupercategory } from './formatSupercategory';

export const getSelectedCategoryName = (
    categoryIds: string[],
    transactionEntryCategories: TransactionEntryCategoryFieldsFragment[],
    transactionEntryCategoriesMapById: Record<
        string,
        TransactionEntryCategoryFieldsFragment
    >
): string | null => {
    if (categoryIds.length === 1) {
        // If there is only one category, then use the category name
        return transactionEntryCategoriesMapById[categoryIds[0]]?.name;
    } else {
        // If there are multiple categories, and they all belong to the same parent category, then use the parent category name
        const parentCategories = new Set<string>();
        const superCategories = new Set<string>();

        categoryIds.forEach((categoryId) => {
            const category = transactionEntryCategoriesMapById[categoryId];

            if (category) {
                parentCategories.add(category.categoryGroup.name);
                superCategories.add(category.categoryGroup.supercategory);
            }
        });

        if (parentCategories.size === 1 || superCategories.size === 1) {
            const parentCategoryName = parentCategories.values().next().value;
            const superCategoryName = superCategories.values().next().value;

            const { categoryGroups, supercategoryGroups } =
                buildBaseCategoryGroups(transactionEntryCategories);

            // Only show the supercategory name if *every* option in the supercategory is selected
            if (
                superCategoryName &&
                supercategoryGroups[superCategoryName]
                    .transactionEntryCategories.length === categoryIds.length
            ) {
                return formatSupercategory(superCategoryName);
            }

            // Only show the parent category name if *every* option in the category is selected
            if (
                parentCategoryName &&
                categoryGroups[parentCategoryName].transactionEntryCategories
                    .length === categoryIds.length
            ) {
                return parentCategoryName;
            }
        }
    }

    return null;
};
